module.exports = __webpack_public_path__ + "fonts/KFhimaji.2a08510c.woff";